module.exports = __webpack_public_path__ + "static/media/ArrowRight.02cb2423.svg";